import { get, startsWith } from 'lodash'
import moment from 'moment'
import { push } from 'connected-react-router'
import ReactGA from 'react-ga4'
import _ from 'lodash'
import Cookies from 'js-cookie'
import { getToken, getSignupRole } from 'utils/token'
import { getCSRFToken, getORBg02CSRFToken, refreshAccessToken, saveUser } from 'redux/modules/auth'
import { noApiConnection } from 'redux/modules/app'
import { TOKEN_STATES } from 'constants/enums'
import { toDash } from 'utils/intl'
import { ga } from 'constants/misc'
import sentry from 'utils/sentry'
import config from 'config'

export default function clientMiddleware(client) {
  return ({ dispatch, getState }) => {
    return next => action => {
      if (typeof action === 'function') {
        return action(dispatch, getState)
      }

      const store = getState()
      const token = get(store, 'auth.user.access_token')
      // const expiresIn = get(store, 'auth.user.expires_in')
      const refreshToken = get(store, 'auth.user.refresh_token')
      const exp = get(store, 'auth.user.exp')
      const userType = getSignupRole(get(store, 'auth.user'))

      if (!token || !shouldCheckAction(action)) {
        return createPromise({ next, action, client, getState, dispatch })
      }

      if (moment().isAfter(exp)) {
        console.log('Token expired!')
        return handleRefreshToken(dispatch, refreshToken, {
          next,
          action,
          client,
          getState,
          userType,
        })
      }

      console.log("XXX config.isCSRFEnabled", config.isCSRFEnabled)
      if (config.isCSRFEnabled === 'true') {
        console.log("XXX ********* CSRF IS ENABLED ***********")

        const orbg01Token = Cookies.get('csrfts')
        const orbg02Token =  Cookies.get('XSRF-TOKEN')

        console.log("XXX orbg01Token", orbg01Token)
        console.log("XXX orbg02Token", orbg02Token)

        let promise = null

        if (orbg01Token === null || orbg01Token === undefined) {
          console.log('CSRF token orbg01 not found!')
          promise = handleGetCSFRToken(dispatch, {
            next,
            action,
            client,
            getState
          })
        }

        if (orbg02Token === null || orbg02Token === undefined) {
          console.log('CSRF token orbg02 not found!')
          promise = handleGetORBg02CSFRToken(dispatch, {
            next,
            action,
            client,
            getState
          })
        }

        if(promise){
          return promise
        }
      }

      return createPromise({
        next,
        action,
        client,
        getState,
        dispatch,
      }).catch(err => {
        if (get(err, 'body.errorCode') === 'TOKEN_EXP' && moment().isBefore(exp)) {
          handleRefreshToken(dispatch, refreshToken, {
            next,
            action,
            client,
            getState,
            userType,
          })
        }
        throw err
      })
    }
  }
}

function sendError(errorType, error, tags) {
  if (typeof (window) !== 'undefined') {
    ReactGA.event({
      category: ga.CATEGORY,
      action: ga.ACTION,
      label: errorType
    })
  }

  sentry.logError(errorType, error, tags)
}

function createPromise({ next, action, client, getState, dispatch, userType }) {
  const { promise, types, ...rest } = action

  if (!promise) {
    return next(action)
  }

  const [REQUEST, SUCCESS, FAILURE] = types
  const store = getState()
  const tags = {
    personId: get(store, 'auth.user.personId'),
    organizationId: get(store, 'auth.organization.id'),
    userType: get(store, 'auth.organization.userType')
  }

  let locale = get(store, 'app.locale.code')

  if (__CLIENT__ && window && window.location && !locale) {
    locale = handleGetUrlLocaleValue()
  }

  client.token = getToken(get(store, 'auth.user'))
  client.locale = toDash(locale)
  client.organizationId = get(store, 'auth.organization.id')
  client.userType = userType || get(store, 'auth.organization.role')
  client.dispatch = dispatch

  next({ ...rest, type: REQUEST })

  const actionPromise = promise(client)

  actionPromise
    .then(
      props => {
        const { body, headers, timeStamp, endpoint, requireJson } = props

        if (requireJson && headers && headers['content-type'] &&
          (!startsWith(headers['content-type'], 'application/json')
            || (!_.isEmpty(body) && typeof body !== 'object'))
        ) {
          console.log('Bad JSON response', props)

          dispatch(noApiConnection(true))

          next({ ...rest, error: body, type: FAILURE })

          tags.apiEndpoint = endpoint
          sendError(ga.NO_ACTIVE_CONNECTION, props, tags)
        } else {
          return next({
            ...rest,
            result: body || {},
            headers,
            timeStamp,
            endpoint,
            type: SUCCESS,
          })
        }
      },
      props => {
        const { body = {}, err, endpoint, headers, requireJson } = props

        let badGatewayError = false
        let gaError = null
        let parsedBody = {}
        const httpResponseStatus = get(err, 'status')

        try {
          parsedBody = typeof body !== 'object' ? JSON.parse(body) : body
        } catch (err) {
          console.log('middleware JSON parse error', err, body)
          gaError = gaError || ga.NO_ACTIVE_CONNECTION
          dispatch(noApiConnection(true))
        }

        if (typeof(navigator) !== 'undefined' && navigator.onLine === false) {
          gaError = gaError || ga.NO_ACTIVE_CONNECTION
          dispatch(noApiConnection(true))
        }

        const isApiV2 = !!get(parsedBody, 'id')

        const errorCode = isApiV2
          ? get(parsedBody, 'code')
          : get(parsedBody, 'errorCode')

        tags.errorCode = errorCode
        tags.status = httpResponseStatus
        tags.apiEndpoint = endpoint

        if (requireJson && headers && headers['content-type'] &&
          (!startsWith(headers['content-type'], 'application/json')
            || (!_.isEmpty(body) && typeof body !== 'object'))
        ) {
          console.log('Bad JSON response', props)
          gaError = gaError || ga.NO_API_CONNECTION
          dispatch(noApiConnection(true))
        }

        if (err && JSON.stringify(err || {}).includes('Bad Gateway')) {
          badGatewayError = true
        }

        if ((get(err, 'crossDomain') && !httpResponseStatus) || badGatewayError) {
          gaError = gaError || (badGatewayError ? ga.BAD_GATEWAY : ga.NO_API_CONNECTION)
          dispatch(noApiConnection(true))
        }

        if (httpResponseStatus === 503
          || (err
            && !httpResponseStatus
            && get(err, 'message')
            && startsWith(get(err, 'message'), 'Request has been terminated'))
        ) {
          gaError = gaError || ga.NO_API_CONNECTION
          dispatch(noApiConnection(true))
        }

        if ((
            (!isApiV2 && errorCode === 'UNAUTHORIZED')
            ||
            (isApiV2 && httpResponseStatus === 403)
          )
          && client.isPublic) {
          location && location.replace('/')
          gaError = gaError || ga.UNAUTHORIZED
          next({ ...rest, error: body, type: FAILURE })
        }


        if (
          (errorCode === TOKEN_STATES.revoked.id ||
            errorCode === TOKEN_STATES.unauthorized.id) &&
          props.unauthorizedAction
        ) {

          gaError = gaError
            || (errorCode === TOKEN_STATES.unauthorized.id ? ga.UNAUTHORIZED : ga.TOKEN_REVOKED)
          dispatch(
            push({
              pathname: `${config.publicPath}/logout`,
              state: { disableNotification: true },
            })
          )

          next({ ...rest, error: body, type: FAILURE })
        } else {
          gaError = gaError || JSON.stringify(props)

          next({ ...rest, error: body, type: FAILURE })
        }

        sendError(gaError || JSON.stringify(props), props, tags)
      }
    )
    .catch(error => {
      console.error('MIDDLEWARE ERROR:', error)
      sendError(`${ga.MIDDLEWARE_ERROR} ${JSON.stringify(error)}`, error, tags)
      next({ ...rest, error, type: FAILURE })
    })

  return actionPromise
}

function handleRefreshToken(dispatch, refreshToken, { next, action, client, getState, userType }) {
  return dispatch(refreshAccessToken(refreshToken, { userType }))
    .then(({ body } = {}) => {
      const updatedUser = {
        ...get(getState(), 'auth.user'),
        ...body,
      }

      dispatch(saveUser(updatedUser))
      return createPromise({ next, action, client, getState, dispatch })
    })
    .catch(refreshErr => {
      console.log('err', refreshErr)
    })
}

function handleGetCSFRToken(dispatch, { next, action, client, getState }) {
  return dispatch(getCSRFToken())
    .then(() => {
      return createPromise({ next, action, client, getState, dispatch })
    })
    .catch(err => {
      throw err
    })
}

function handleGetORBg02CSFRToken(dispatch, { next, action, client, getState }) {
  return dispatch(getORBg02CSRFToken())
    .then(() => {
      return createPromise({ next, action, client, getState, dispatch })
    })
    .catch(err => {
      throw err
    })
}



// returns true if none of actions matches param
function shouldCheckAction(action) {
  const param = action && action.types && action.types[0]
  const usedActions = ['auth', '/app/GET_LOCALIZED_MESSAGES']

  return param ? usedActions.every(elem => param.indexOf(elem) === -1) : false
}

function handleGetUrlLocaleValue() {
  const searchParams = window.location.search.split('&')
  const getLocaleQuery = searchParams.filter(item => item.includes('locale='))[0]

  if (!getLocaleQuery) {
    return 'en-gb'
  }

  const getLocaleQueryValue = getLocaleQuery.split('=')[1]

  return getLocaleQueryValue
}
